import { withAuthenticationRequired } from 'react-oidc-context';

import { PERMISSIONS_VIEW_REQUIRED_PERMISSION } from '../application/security/permissions';

import DefaultLayout from './layout/DefaultLayout';

function Permissions() {
    return (
        <DefaultLayout requiredPermission={PERMISSIONS_VIEW_REQUIRED_PERMISSION}>
            <div>
                <h1>Welcome to permissions</h1>
            </div>
        </DefaultLayout>
    );
}

export default withAuthenticationRequired(Permissions, {
    OnRedirecting: () => <div>Redirecting to the login page...</div>,
});
